import { render, staticRenderFns } from "./RefundFee.vue?vue&type=template&id=3c53c99c&scoped=true"
import script from "./RefundFee.vue?vue&type=script&lang=js"
export * from "./RefundFee.vue?vue&type=script&lang=js"
import style0 from "./RefundFee.vue?vue&type=style&index=0&id=3c53c99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53c99c",
  null
  
)

export default component.exports